import { render, staticRenderFns } from "./ComponentAuthGuard.vue?vue&type=template&id=45ed603a"
import script from "./ComponentAuthGuard.vue?vue&type=script&setup=true&lang=ts"
export * from "./ComponentAuthGuard.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports